<!-- 用户操作 -->
<template>
    <div>
        <el-drawer :close-on-press-escape="true" :title="dataActionBox.boxTitle" :visible.sync="dataActionBox.showStatus"
            :with-header="false" :append-to-body="true" :direction="dataActionBox.openMode" size="50%">
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="formDataList">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'"
                        :tabslist="formDataList" @tabs="(val) => { showTabs = val }">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主信息 -->
                                <div v-if="scope.index == 0">
                                    <el-form size="mini" inline :show-message="false" label-width="120px"
                                        :model="sendDataInfo" ref="sendDataInfo">
                                        <el-form-item label="业务员" prop="opmName"
                                            :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                            <label slot="label" :style="$common.labelStyle('业务员')"
                                                v-html="$common.htmlLabel('业务员')"></label>
                                            <!-- 检索方案 -->
                                            <el-tooltip  class="item" :disabled="sendDataInfo.opmName==null||sendDataInfo.opmName==''?true:false || sendDataInfo.opmName.length<=9" effect="dark"
        :content="sendDataInfo.opmName" placement="bottom-start">
                                            <el-input class="form_codition" clearable v-model="sendDataInfo.opmName"
                                                @keyup.enter.native="openSearch('4444770562019328', 0, 'opmName', 'opmId,opmName,creditMoney,creditPeriod')">
                                                <el-button
                                                    @click="openSearch('4444770562019328', 0, 'opmName', 'opmId,opmName,creditMoney,creditPeriod')"
                                                    slot="append" icon="el-icon-search"></el-button></el-input>
                                                    </el-tooltip>
                                        </el-form-item>
                                        <el-form-item label="授信额度" prop="creditMoney"
                                            :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                            <label slot="label" :style="$common.labelStyle('授信额度')"
                                                v-html="$common.htmlLabel('授信额度')"></label>
                                            <el-input class="form_codition" v-model.trim="sendDataInfo.creditMoney"
                                                placeholder="请输入授信额度" :maxlength="$store.state.inputLength"
                                                type="number"></el-input>
                                        </el-form-item>
                                        <el-form-item label="信贷期" prop="creditPeriod"
                                            :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                            <label slot="label" :style="$common.labelStyle('信贷期')"
                                                v-html="$common.htmlLabel('信贷期')"></label>
                                            <!-- <el-date-picker size="mini" v-model="sendDataInfo.creditPeriod" type="date" placeholder="选择信贷期">
                                            </el-date-picker> -->
                                            <el-input class="form_codition" v-model.trim="sendDataInfo.creditPeriod"
                                                placeholder="请输入信贷期" :maxlength="$store.state.inputLength"
                                                type="number"></el-input>
                                        </el-form-item>
                                    </el-form>
                                </div>

                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <div class="foots">
                    <el-button type="primary" @click="cancel">取消</el-button>
                    <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                        v-if="dataActionBox.actionType == 0">保存</el-button>
                    <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                        v-if="dataActionBox.actionType == 1">保存</el-button>
                </div>
            </div>
            <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" append-to-body>
                <SearchSchemeOther ref="SearchSchemeOther" :id="seId" :parentSearchData="parentSearchData"
                    @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
            </el-dialog>
        </el-drawer>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
    name: "operCreditAction",
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
            token: { token: sessionStorage.getItem('token') },
            showTabs: '',
            formDataList: [],
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {
                creditMoney: "",
                creditPeriod: '',
                opmName: "",
                opmId: "",
            },
            defaultProps: {
                multiple: true,
                expandTrigger: 'hover',
                checkStrictly: true,
                emitPath: false,
            },
            fileList: [],
            allorgList: [],
            dialogImageUrl: '',
            DialogVisible: false,
            selectedDataList: [],
            departmentList: [],
            groupList: [],
            customertype: [{
                lable: 0,
                name: "普通用户",
            },
            {
                lable: 1,
                name: "货主用户",
            },
            ],
            dictionariesData: [], //男女字典
            sField: "",
            seId: "",
            seType: "",
            parentSearchData: {},
            seWidth: "0",
            exWidth: "",
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
    },
    //方法集合
    methods: {
        getSeWidth(e) {
            // console.log(e);
            this.seWidth = e + "%";
        },
        getWidth(e) {
            // console.log(e);
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            // console.log(e);
            this.seTitle = e;
        },
        //检索带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;

                this.paramValue(val)
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.sendDataInfo[item] = val[item]
            })
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            if (type == 'salesName' && this.sendDataInfo.cmId == '') {
                return this.$message({
                    message: '请先选择购进单位',
                    type: "warning",
                });
            }
            this.DialogVisible = true
            this.seType = type
            this.seId = sId
            this.sField = sField
            this.parentSearchData[type] = this.sendDataInfo[type]
        },
        cancel() {
            this.dataActionBox.showStatus = false
        },


        initActionBox() {
            for (let key in this.sendDataInfo) {
                this.sendDataInfo[key] = "";
            }
            this.sendDataInfo.opmCode = this.$common.createUserCode();
            this.sendDataInfo.opmAcceptor = 0;
            this.sendDataInfo.opmBuyer = 0;
            this.sendDataInfo.opmDelivery = 0;
            this.sendDataInfo.opmCashier = 0;
            this.sendDataInfo.opmDoctor = 0;
            this.sendDataInfo.opmHeader = 0;
            this.sendDataInfo.opmKeeper = 0;
            this.sendDataInfo.opmPharmacist = 0;
            this.sendDataInfo.opmReviewer = 0;
            this.sendDataInfo.opmSalesperson = 0;
            this.sendDataInfo.opmSex = '男';
            this.sendDataInfo.opmAdmin = 0;
            this.sendDataInfo.opmJob = '';
            this.sendDataInfo.opmDriver = 0;
            this.sendDataInfo.opmDistributor = 0;
            this.sendDataInfo.opmSpc = 0;
            this.sendDataInfo.opmPrice = 0;
            this.sendDataInfo.opmOrder = 0;
            this.sendDataInfo.opmSitelogin = 0;
            this.sendDataInfo.isPrint = 1;
            this.sendDataInfo.opmExport = 1;
            // this.sendDataInfo.ormIds = []

            this.selectDepartmentPath = "";
            this.dataActionBox.actionType = 0;
            this.dataActionBox.showStatus = false;
        },

        async openBox(cate, departmentList, oldData = "") {
            this.fileList = []
            this.departmentList = departmentList;
            console.log(this.departmentList);
            if (cate == 0) {
                this.initActionBox();
                this.dataActionBox.boxTitle = "新增信息";
                this.dataActionBox.openMode = "ltr";
                this.sendDataInfo.uploadVoList = []
                this.showTabs = "新增业务员授信"
                this.formDataList = [
                    {
                        jciName: "新增业务员授信",
                        jurconfigform: [],
                    }
                ]
            } else {

                this.dataActionBox.boxTitle = "编辑信息";
                this.showTabs = "编辑业务员授信"
                this.dataActionBox.openMode = "ltr";
                for (let key in oldData) {
                    this.sendDataInfo[key] = oldData[key];
                }
                this.formDataList = [
                    {
                        jciName: "编辑业务员授信",
                        jurconfigform: [],
                    }
                ]
            }
            this.dataActionBox.actionType = cate;
            this.dataActionBox.showStatus = true;
        },

        sendDataAction(sendDataInfo) {

            this.$refs[sendDataInfo].validate((valid) => {
                if (valid) {
                    this.sub();
                } else {
                    this.$message({
                        message: '请完善必填信息',
                        type: "error",
                    });
                    return false;
                }
            });
        },
        async sub() {
            var sendDataInfo = JSON.parse(JSON.stringify(this.sendDataInfo));
            if (this.dataActionBox.actionType == 0) {
                var responseData = await this.$http.opercreditAdd(sendDataInfo);
            } else {
                var responseData = await this.$http.opercreditUpdate(sendDataInfo);
            }
            if (responseData.status == 200) {
                this.initActionBox();
                this.$message({
                    message: "操作成功",
                    type: "success",
                });

                this.$parent.getDataList();
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 获取字典数据
        async getPartDictionariesData() {
            let responseData = await this.$http.getCateDictionariesData({
                ids: [1],
            });
            if (responseData.status == 200) {
                this.dictionariesData = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "字典项获取失败",
                });
            }
        },

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        // this.getGroupList();
        this.getPartDictionariesData();
        // this.getOrgList()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped></style>